import React, { useEffect, useState } from 'react'

import SuccessModal from "HELPDESK/CommonResources/SuccessModal/SuccessModal";
import HelpDeskApiCall from 'HelpdeskApiCall';
import '../Onboarding/Onboarding.css';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';

import classicIC from "HELPDESK/CommonResources/images/classic.png";
import premiumIC from "HELPDESK/CommonResources/images/premium.png";
import enterpriseIC from "HELPDESK/CommonResources/images/enterprise.png";
import activeIc from 'HELPDESK/CommonResources/images/active.svg';
import inactiveIc from 'HELPDESK/CommonResources/images/unactive.svg';
import selectedIC from 'HELPDESK/CommonResources/images/selected.svg';
import { Base64 } from 'js-base64';

const Onboarding = () => {
    const [activeTab, setActiveTab] = useState("productTrainingTab");
    const borderStyling = {};
    // const borderStyling = { borderBottom: '2px solid black', width: 'fit-content', cursor: 'pointer' };

    const switchTab = (tab) => {
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    }
    return (
        <div className="root">
            <div className="container-fluid pr-0">
                <div className="col-md-12 pr-0">
                    <div className="tabsView pl-3 pt-3 row w-100">
                        <div className="clsUnderline mb-0 pb-0" style={activeTab === "productTrainingTab" ? borderStyling : { cursor: 'pointer' }} onClick={() => switchTab("productTrainingTab")}>
                            <label className="headerText mb-0" style={{ cursor: 'pointer', color: activeTab === "productTrainingTab" ? "#4A4B57" : "#B8B8B8" }}>Product Training</label>
                        </div>
                        {/* <div className="clsUnderline mb-0 pb-0 ml-4" style={activeTab === "onboardingTab" ? borderStyling : { cursor: 'pointer' }} onClick={() => switchTab("onboardingTab")}>
                            <label className="headerText mb-0" style={{ cursor: 'pointer', color: activeTab === "onboardingTab" ? "#4A4B57" : "#B8B8B8" }}>Onboarding</label>
                        </div> */}
                    </div>
                    <div className="m-2" />
                    {activeTab === "productTrainingTab" ? <ProductTraining /> : <OnboardingTab />}
                </div>
            </div>
        </div>
    )
}


export default Onboarding;

const ProductTraining = () => {

    const [productTrainingData, setProductTrainingData] = useState({})

    const [selectedAttachments, setSelectedAttachments] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [subModuleData, setSubModuleData] = useState([]);
    const [demoPointData, setDemoPointData] = useState([]);
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [documentsData, setDocumentsData] = useState([]);
    const [meetingData, setMeetingsData] = useState([]);

    const [loadingProductTrainingData, setLoadingProductTrainingData] = useState(false)
    const [loadingModuleAttachments, setLoadingModuleAttachments] = useState(false)
    const [showProductTrainingModal, setShowProductTrainingModal] = useState(false)
    const [loadingModuleDocuments, setLoadingModuleDocuments] = useState(false)
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false)
    const [loadingAddAttachment, setLoadingAddAttachment] = useState(false)
    const [showDocumentModal, setShowDocumentModal] = useState(false)
    const [loadingSubModules, setLoadingSubModules] = useState(false)
    const [loadingDemoData, setLoadingDemoData] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    const [selectedSubscriptionPackage, setSelectedSubscriptionPackage] = useState('')
    const [filterStatusDocument, setFilterStatusDocument] = useState('');
    const [selectedImageStatus, setSelectedImageStatus] = useState('active')
    const [selectedDemoPointId, setSelectedDemoPointId] = useState('');
    const [filterStatus, setFilterStatus] = useState('active');
    const [demoPointError, setDemoPointError] = useState('');
    const [successMessage, setSuccessMessage] = useState('')
    const [successType, setSuccessType] = useState('')
    const [selectedModuleName, setSelectedModuleName] = useState('Academic Planning')

    const [attachmentPageIndex, setAttachmentPageIndex] = useState(1);
    const [documentPageIndex, setDocumentPageIndex] = useState(1);
    const [attachmentsLimit, setAttachmentLimit] = useState(10);
    const [totalAttachments, setTotalAttachments] = useState(0);
    const [totalDocuments, setTotalDocuments] = useState(0);
    const [documentsLimit, setDocumentsLimit] = useState(10);

    const [selectedDemoPointIdForDocument, setSelectedDemoPointIdForDocument] = useState('');
    const [selectedDocumentStatus, setSelectedDocumentStatus] = useState('active');
    const [selectedModuleId, setSelectedModuleId] = useState('');
    const [selectedSubModuleId, setSelectedSubModuleId] = useState('');
    const [landscapeFileError, setLandscapeFileError] = useState('');
    const [statusError, setStatusError] = useState('');

    const sortedPhases = ['phase1', 'phase2', 'phase3', 'phase4', 'phase5'];

    useEffect(() => apiCallToGetProductTrainingData(), []);
    useEffect(() => filterAttachments(), [filterStatus]);
    useEffect(() => {
        if (selectedModuleId != '') {
            apiCallToGetModuleAttachments(selectedModuleId);
        }
    }, [attachmentPageIndex]);

    useEffect(() => {
        if (selectedModuleId != '') {
            apiCallToGetModuleDocuments(selectedModuleId);
        }
    }, [documentPageIndex]);

    useEffect(() => {
        if (selectedModuleId != '') {
            const type = "product-delivery-confirmation";
            apiCallToGetDemoPointList(selectedModuleId, type)
        }
    }, [selectedSubModuleId]);

    const filterAttachments = () => {
        setAttachmentsData([]);
        setTotalAttachments(0);
        setAttachmentPageIndex(1);
        setAttachmentLimit(10);
        if (selectedModuleId != '') {
            apiCallToGetModuleAttachments(selectedModuleId);
        }
    }

    const selectAttachment = (id) => {
        // Check if the id is already present in selectedAttachments
        const isIdSelected = selectedAttachments.includes(id);

        if (isIdSelected) {
            // If id is already selected, remove it from selectedAttachments
            setSelectedAttachments(selectedAttachments.filter(item => item !== id));
        } else {
            // If id is not selected, add it to selectedAttachments
            setSelectedAttachments([...selectedAttachments, id]);
        }
    };

    const apiCallToGetProductTrainingData = async () => {
        setLoadingProductTrainingData(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getProductTrainingDataForOnboarding',
                { instituteId: config.institute_id },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetProductTrainingData, 1000); // Removed "this."
            } else {
                if (jsonResponse.success) {
                    const { data, subscriptionType } = jsonResponse?.APIResult;
                    setProductTrainingData(data);
                    setSelectedSubscriptionPackage(subscriptionType || "");
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }
        } catch (error) {
            console.log("Error in apiCallToGetProductTrainingData:", error);
        } finally {
            setLoadingProductTrainingData(false);
        }
    };

    const apiCallToGetDemoPointList = async (moduleId, type) => {
        setLoadingDemoData(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getClientDemoPointsList',
                { module_id: moduleId, type, sub_module_id: selectedSubModuleId },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetDemoPointList, 1000); // Removed "this."
            } else {
                if (jsonResponse.success) {
                    const { data } = jsonResponse?.APIResult;
                    setDemoPointData(Object?.values(data) || []);
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }

        } catch (error) {
            console.log("Error in apiCallToGetDemoPointList:", error);
        } finally {
            setLoadingDemoData(false);
        }
    }

    const apiCallToGetDemoMeetingList = async (moduleId) => {
        setLoadingDemoData(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getClientMeetingList',
                { module_id: moduleId, client_id: config.institute_id },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetDemoMeetingList, 1000); // Removed "this."
            } else {
                if (jsonResponse.success) {
                    const { data } = jsonResponse?.APIResult;
                    setMeetingsData(Object?.values(data) || []);
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }

        } catch (error) {
            console.log("Error in apiCallToGetDemoMeetingList:", error);
        } finally {
            setLoadingDemoData(false);
        }
    }

    const apiCallToGetSubModuleList = async (moduleId) => {
        setLoadingSubModules(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getPMSubModulesList',
                { module_id: moduleId,"onlyDocumentationDemoPoints":"true" },
                '/api/projectManagement/settings/moduleInformation.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetSubModuleList, 1000); // Removed "this."
            } else {
                if (jsonResponse.success) {
                    const { data, sequenceIdArray } = jsonResponse?.APIResult;
                    const subModuleData = sequenceIdArray?.length > 0 ? sequenceIdArray?.map(id => data[id]) : [];
                    setSubModuleData(subModuleData);
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }

        } catch (error) {
            console.log("Error in apiCallToGetDemoPointList:", error);
        } finally {
            setLoadingSubModules(false);
        }
    }

    const apiCallToAddPMAttachments = async () => {
        setLoadingAddAttachment(true);

        try {
            let isValid = true;

            if (selectedImageStatus === "" && selectedDemoPointId === "") {
                setStatusError('Please select a status before continuing.');
                setDemoPointError('Please select a demo before continuing.');
                isValid = false;
            } else if (selectedImageStatus === "") {
                setStatusError('Please select a status before continuing.');
                isValid = false;
            } else if (selectedDemoPointId === "") {
                setDemoPointError('Please select a demo before continuing.');
                isValid = false;
            }

            if (!isValid) {
                setTimeout(() => {
                    setStatusError('');
                    setDemoPointError('');
                }, 2000);
                return;
            }

            const formData = new FormData();
            formData.append('addPMAttachments', true);
            formData.append('data', Base64.encode(JSON.stringify({
                "client_id": config.institute_id,
                "module_id": selectedModuleId,
                "client_demo_id": selectedDemoPointId,
                "status": selectedImageStatus,
                "addedBy": config.faculty_id,
            })));

            attachedFiles.forEach(attachment => {
                formData.append('file[]', attachment);
            });

            const parameterData = JSON.stringify({
                source: 'app',
                uid: config.faculty_id,
                email: config.emailId,
                role: 'instructor'
            });

            formData.append('tokenInputParameter', Base64.encode(parameterData));

            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            const response = await axios.post(
                `${config.RootUrl}/api/projectManagement/client/productTraining.php`,
                formData,
                { headers }
            );

            if (response.data.success) {
                // Handle success
                setSuccessModal(true);
                setSuccessType('success');
                setSuccessMessage(response.data.message);

                setSelectedDemoPointId('');
                setSelectedImageStatus('');
                // setSelectedModuleId('');
                setUploadedImages([]);
                setAttachedFiles([]);
                filterAttachments();
                apiCallToGetProductTrainingData();
            }
        } catch (error) {
            console.log("Error - apiCallToAddPMAttachments", error);
        } finally {
            setLoadingAddAttachment(false);
        }
    };

    const apiCallToAddPMDocuments = async () => {
        setLoadingAddAttachment(true);

        try {

            let isValid = true;

            if (selectedDocumentStatus === "" && selectedDemoPointIdForDocument === "") {
                setStatusError('Please select a status before continuing.');
                setDemoPointError('Please select a demo before continuing.');
                isValid = false;
            } else if (selectedDocumentStatus === "") {
                setStatusError('Please select a status before continuing.');
                isValid = false;
            } else if (selectedDemoPointIdForDocument === "") {
                setDemoPointError('Please select a demo before continuing.');
                isValid = false;
            }

            if (!isValid) {
                setTimeout(() => {
                    setStatusError('');
                    setDemoPointError('');
                }, 2000);
                return;
            }

            const formData = new FormData();
            formData.append('addPMDocument', true);
            formData.append('data', Base64.encode(JSON.stringify({
                "client_id": config.institute_id,
                "module_id": selectedModuleId,
                "sub_module_id": selectedSubModuleId,
                "client_demo_id": selectedDemoPointIdForDocument,
                "status": selectedDocumentStatus,
                "addedBy": config.faculty_id,
            })));

            attachedFiles.forEach(attachment => {
                formData.append('file[]', attachment);
            });

            const parameterData = JSON.stringify({
                source: 'app',
                uid: config.faculty_id,
                email: config.emailId,
                role: 'instructor'
            });

            formData.append('tokenInputParameter', Base64.encode(parameterData));

            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            const response = await axios.post(
                `${config.RootUrl}/api/projectManagement/client/productTraining.php`,
                formData,
                { headers }
            );

            if (response.data.success) {
                // Handle success
                setSuccessModal(true);
                setSuccessType('success');
                setSuccessMessage(response.data.message);

                setSelectedDemoPointIdForDocument('');
                setSelectedDocumentStatus('');
                setSelectedSubModuleId('');
                setDocumentPageIndex(1);
                setUploadedImages([]);
                setAttachedFiles([]);
                apiCallToGetModuleDocuments(selectedModuleId);
                apiCallToGetProductTrainingData();
            }
        } catch (error) {
            console.log("Error - apiCallToAddPMAttachments", error);
        } finally {
            setLoadingAddAttachment(false);
        }
    };

    const apiCallToGetModuleAttachments = async (moduleId) => {
        setLoadingModuleAttachments(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getModuleAttachments',
                { client_id: config.institute_id, module_id: moduleId, status: filterStatus, page_index: attachmentPageIndex, limit: attachmentsLimit },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetModuleAttachments, 1000);
            } else {
                if (jsonResponse.success) {
                    const { data, totalAttachments } = jsonResponse?.APIResult;
                    // Append new data to existing data
                    setAttachmentsData(prevData => [...prevData, ...(Object?.values(data) || [])]);
                    setTotalAttachments(totalAttachments);
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }
        } catch (error) {
            console.log("Error in apiCallToGetModuleAttachments:", error);
        } finally {
            setLoadingModuleAttachments(false);
        }
    }

    const apiCallToUpdateAttachmentStatus = async () => {
        setIsUpdating(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'updatePMAttachmentsStatus',
                {
                    client_id: config.institute_id,
                    uniqueIdArray: selectedAttachments,
                    status: filterStatus === "active" ? "inactive" : "active",
                    updatedBy: config.faculty_id,
                },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToUpdateAttachmentStatus, 1000); // Removed "this."
            } else {
                if (jsonResponse.success) {
                    setSuccessModal(true);
                    setSuccessType('success');
                    setSuccessMessage(jsonResponse.APIResult.message);

                    setSelectedAttachments([]);
                    filterAttachments();
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }
        } catch (error) {
            console.log("Error in apiCallToGetModuleDocuments:", error);
        } finally {
            setIsUpdating(false);
        }
    }

    const apiCallToGetModuleDocuments = async (moduleId) => {
        setLoadingModuleDocuments(true);
        try {
            const jsonResponse = await HelpDeskApiCall.makeApiCall(
                'getModuleDocuments',
                { client_id: config.institute_id, module_id: moduleId, status: filterStatusDocument, page_index: documentPageIndex, limit: documentsLimit },
                '/api/projectManagement/client/productTraining.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetModuleDocuments(moduleId), 1000);
            } else {
                if (jsonResponse.success) {
                    const { data, totalDocuments } = jsonResponse?.APIResult;
                    // Append new data to existing data
                    setDocumentsData(prevData => [...prevData, ...(Object?.values(data) || [])]);
                    setTotalDocuments(totalDocuments);
                } else {
                    setSuccessModal(true);
                    setSuccessType('error');
                    setSuccessMessage(jsonResponse.APIResult.message);
                }
            }
        } catch (error) {
            console.log("Error in apiCallToGetModuleDocuments:", error);
        } finally {
            setLoadingModuleDocuments(false);
        }
    }

    const handlePrintReport = () => {
        // console.log("Hey ...");
    }

    const closeSuccessModal = () => setSuccessModal(false);

    const renderSubscriptionModal = () => {
        const data = [
            {
                header: "Criteria",
                isHeader: true,
                classicValue: "Classic Subscription",
                classicSubValue: "",
                premiumValue: "Premium Subscription",
                premiumSubValue: "",
                enterpriseValue: "Enterprise Subscription",
                enterpriseSubValue: "",
            },
            {
                header: "Cost",
                isHeader: false,
                classicValue: "Included in the Pricing",
                classicSubValue: "",
                premiumValue: "20% of your Subscription Fee",
                premiumSubValue: "",
                enterpriseValue: "30% of your Subscription Fee",
                enterpriseSubValue: "",
            },
            {
                header: "Availability",
                isHeader: false,
                classicValue: "09:30 AM to 04:30 PM",
                classicSubValue: "Monday to Friday",
                premiumValue: "09:30 AM to 05:30 PM",
                premiumSubValue: "Monday to Friday",
                enterpriseValue: "09:30 AM to 06:30 PM",
                enterpriseSubValue: "Monday to Saturday",
            },
            {
                header: "Call Acknowledgement & Initial Response Time",
                isHeader: false,
                classicValue: "Up-to 2 Hr 30 Min.",
                classicSubValue: "",
                premiumValue: "Up-to 1 Hr 30 Min.",
                premiumSubValue: "",
                enterpriseValue: "Up-to 30 Min.",
                enterpriseSubValue: "",
            },
            {
                header: "Onboarding Specialist",
                isHeader: false,
                classicValue: "Not Applicable",
                classicSubValue: "",
                premiumValue: "Available",
                premiumSubValue: "",
                enterpriseValue: "Available",
                enterpriseSubValue: "",
            },
            {
                header: "Onboarding Duration",
                isHeader: false,
                classicValue: "25 days from date of subscription",
                classicSubValue: "",
                premiumValue: "45 days from date of subscription",
                premiumSubValue: "",
                enterpriseValue: "60 days from date of subscription",
                enterpriseSubValue: "",
            },
            {
                header: "Maximum number of onboarding sessions, valid only for the duration of onboarding",
                isHeader: false,
                classicValue: "3 per week",
                classicSubValue: "",
                premiumValue: "5 per week",
                premiumSubValue: "",
                enterpriseValue: "As per demand",
                enterpriseSubValue: "",
            },
            {
                header: "Session Length",
                isHeader: false,
                classicValue: "30 Min.",
                classicSubValue: "",
                premiumValue: "60 Min.",
                premiumSubValue: "",
                enterpriseValue: "1 Hr. 30 Min.",
                enterpriseSubValue: "",
            },
            {
                header: "Knowledge Base",
                isHeader: false,
                classicValue: "Not Applicable",
                classicSubValue: "",
                premiumValue: "Yes",
                premiumSubValue: "",
                enterpriseValue: "Yes",
                enterpriseSubValue: "",
            },
            {
                header: "Self-service portal (Help Desk)",
                isHeader: false,
                classicValue: "11:00 AM to 04:00 PM.",
                classicSubValue: "Monday to Friday",
                premiumValue: "09:30 AM to 05:30 PM",
                premiumSubValue: "Monday to Friday",
                enterpriseValue: "09:00 AM to 06:30 PM",
                enterpriseSubValue: "Monday to Saturday",
            },
            {
                header: "Phone Support - IVR Line",
                isHeader: false,
                classicValue: "11:00 AM to 04:00 PM.",
                classicSubValue: "Monday to Friday",
                premiumValue: "09:30 AM to 05:30 PM",
                premiumSubValue: "Monday to Friday",
                enterpriseValue: "09:00 AM to 06:30 PM",
                enterpriseSubValue: "Monday to Saturday",
            },
            {
                header: "Remote Assistant",
                isHeader: false,
                classicValue: "11:00 AM to 04:00 PM.",
                classicSubValue: "Monday to Friday",
                premiumValue: "09:30 AM to 05:30 PM",
                premiumSubValue: "Monday to Friday",
                enterpriseValue: "09:00 AM to 06:30 PM",
                enterpriseSubValue: "Monday to Saturday",
            },
            {
                header: "Support for external connected applications and integrations that are beyond vmedulife’s scope",
                isHeader: false,
                classicValue: "Not Applicable",
                classicSubValue: "",
                premiumValue: "Paid, based on the man-hours involve",
                premiumSubValue: "",
                enterpriseValue: "Paid, based on the man-hours involve",
                enterpriseSubValue: "",
            },
        ];

        const totalObjects = Object?.values(data)?.length;

        return (
            <div className={showSubscriptionModal ? "modal fade show container-fluid" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered model-xl" style={{ maxWidth: "80%", borderRadius: 10 }}>
                    <div className="modal-content">
                        <div className="modal-header m-0 pb-0 col-md-12 row justify-content-between align-items-center">
                            <label className="subscriptionHeadertext pl-2">Support Packages</label>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginRight: 5, cursor: 'pointer' }} onClick={() => setShowSubscriptionModal(false)} color="#000000" size="md" />
                        </div>
                        <div className="modal-body m-0 mt-3 pt-0" style={{ height: '80vh', maxHeight: '90vh' }}>
                            {
                                data?.map((item, index) => {
                                    const { header, isHeader, classicValue, premiumValue, enterpriseValue, classicSubValue, premiumSubValue, enterpriseSubValue } = item;
                                    const bgColorHeader = isHeader ? "#E1E4E9" : index % 2 != 0 ? "#F0F4F8" : "#E6EBEFE5";
                                    const bgColorClassic = isHeader ? "#D7EBFF" : index % 2 != 0 ? "#F0F7FF" : "#D7EBFF";
                                    const bgColorPremium = isHeader ? "#FDDFB0" : index % 2 != 0 ? "#FFFCF8" : "#FFF5E4";
                                    const bgColorEnterprise = isHeader ? "#9EFFAE" : index % 2 != 0 ? "#F2FFF8" : "#D7FCE7";
                                    const selectedSubscriptionStyle = {
                                        borderLeft: '2.4px solid #9747FF',
                                        borderRight: '2.4px solid #9747FF',
                                        borderTop: index === 0 && '2.4px solid #9747FF',
                                        borderBottom: index === totalObjects - 1 && '2.4px solid #9747FF',
                                    };

                                    const selectedCardStyle = `col-md-3 topPaddingClass ${index === 0 && "borderRadiusTop pt-2"} ${index === totalObjects - 1 && "borderRadiusBottom pb-2"}`;
                                    const nonSelectedCardStyle = `col-md-3 topPaddingClass pt-0 pb-0`;

                                    return (
                                        <>
                                            <div className="col-md-12 p-0 w-100 d-flex row justify-content-around">
                                                <div className={nonSelectedCardStyle} style={{}}>
                                                    <div className="subscriptionCard p-2 pl-4 " style={{ backgroundColor: bgColorHeader }}>
                                                        {
                                                            isHeader
                                                                ?
                                                                <label className='subscriptionValueTextHeader font-weight-bold m-0'>{header || ""}</label>
                                                                :
                                                                <div className='d-flex flex-column pl-2 pt-2 m-0'>
                                                                    <label className='subscriptionValueTextHeader'>{header || ""}</label>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className={selectedSubscriptionPackage?.toLowerCase() === "classic" ? `${selectedCardStyle}` : nonSelectedCardStyle} style={selectedSubscriptionPackage?.toLowerCase() === "classic" ? selectedSubscriptionStyle : {}}>
                                                    <div className="subscriptionCard p-2" style={{ backgroundColor: bgColorClassic }}>
                                                        {
                                                            isHeader
                                                                ?
                                                                <div className="row justify-content-start align-items-center pt-2 pl-2">
                                                                    <input
                                                                        type="radio"
                                                                        disabled
                                                                        style={{ width: "6%", }}
                                                                        className='form-control'
                                                                        value="Classic"
                                                                        checked={selectedSubscriptionPackage?.toLowerCase() === "classic"}
                                                                        onChange={() => this.setState({ selectedSubscriptionPackage: "Classic" })}
                                                                    />
                                                                    <img src={classicIC} className='ml-2 mr-2' alt="" style={{ width: 25, height: 22 }} />
                                                                    <label className='subscriptionValueTextHeader m-0 font-weight-bold' style={{ color: '#9747FF', fontSize: 15 }}>{classicValue || ""}</label>
                                                                </div>
                                                                :
                                                                <div className='d-flex flex-column pl-2 pt-2'>
                                                                    <label className='subscriptionValueText'>{classicValue || ""}</label>
                                                                    {
                                                                        classicSubValue != "" && (
                                                                            <label className='subscriptionValueText'>{classicSubValue || ""}</label>
                                                                        )
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className={selectedSubscriptionPackage?.toLowerCase() === "premium" ? `${selectedCardStyle}` : nonSelectedCardStyle} style={selectedSubscriptionPackage?.toLowerCase() === "premium" ? selectedSubscriptionStyle : {}}>
                                                    <div className="subscriptionCard p-2 pl-4" style={{ backgroundColor: bgColorClassic }}>
                                                        {
                                                            isHeader
                                                                ?
                                                                <div className="row justify-content-start align-items-center pt-2 pl-2">
                                                                    <input
                                                                        type="radio"
                                                                        disabled
                                                                        style={{ width: "6%", }}
                                                                        className='form-control'
                                                                        value="Premium"
                                                                        checked={selectedSubscriptionPackage?.toLowerCase() === "premium"}
                                                                        onChange={() => this.setState({ selectedSubscriptionPackage: "Premium" })}
                                                                    />
                                                                    <img src={premiumIC} className='ml-2 mr-2' alt="" style={{ width: 25, height: 22 }} />
                                                                    <label className='subscriptionValueTextHeader m-0 font-weight-bold' style={{ color: '#F39C12', fontSize: 15 }}>{premiumValue || ""}</label>
                                                                </div>
                                                                :
                                                                <div className='d-flex flex-column pl-2 pt-2'>
                                                                    <label className='subscriptionValueText'>{premiumValue || ""}</label>
                                                                    {
                                                                        premiumSubValue != "" && (
                                                                            <label className='subscriptionValueText'>{premiumSubValue || ""}</label>
                                                                        )
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className={selectedSubscriptionPackage?.toLowerCase() === "enterprise" ? `${selectedCardStyle}` : nonSelectedCardStyle} style={selectedSubscriptionPackage?.toLowerCase() === "enterprise" ? selectedSubscriptionStyle : {}}>
                                                    <div className="subscriptionCard p-2 pl-4" style={{ backgroundColor: bgColorClassic }}>
                                                        {
                                                            isHeader
                                                                ?
                                                                <div className="row justify-content-start align-items-center pt-2 pl-2">
                                                                    <input
                                                                        type="radio"
                                                                        disabled
                                                                        style={{ width: "6%", }}
                                                                        className='form-control'
                                                                        value="Enterprise"
                                                                        checked={selectedSubscriptionPackage?.toLowerCase() === "enterprise"}
                                                                        onChange={() => this.setState({ selectedSubscriptionPackage: "Enterprise" })}
                                                                    />
                                                                    <img src={enterpriseIC} className='ml-2 mr-2' alt="" style={{ width: 25, height: 22 }} />
                                                                    <label className='subscriptionValueTextHeader m-0 font-weight-bold' style={{ color: '#27AE60', fontSize: 15 }}>{enterpriseValue || ""}</label>
                                                                </div>
                                                                :
                                                                <div className='d-flex flex-column pl-2 pt-2'>
                                                                    <label className='subscriptionValueText'>{enterpriseValue || ""}</label>
                                                                    {
                                                                        enterpriseSubValue != "" && (
                                                                            <label className='subscriptionValueText'>{enterpriseSubValue || ""}</label>
                                                                        )
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const onFileChange = event => {
        const files = Array.from(event.target.files);

        const invalidFiles = files.filter(file => {
            const fileName = file.name;
            const fileSize = file.size / 1024 / 1024; // in MB
            const fileExtension = fileName.split('.').pop().toLowerCase();
            const allowedFileExtensions = ['jpeg', 'png', 'jpg'];

            if (!allowedFileExtensions.includes(fileExtension)) {
                alert(`Invalid file type for ${fileName}. Please choose a valid file.`);
                return true;
            } else if (fileSize > 5) {
                alert(`File size exceeds 5MB for ${fileName}.`);
                return true;
            }

            return false;
        });

        if (invalidFiles.length === 0) {
            const newImages = files.map(file => ({
                name: file.name,
                extension: file.name.split('.').pop().toUpperCase(),
            }));

            setAttachedFiles(prevAttachedFiles => [...prevAttachedFiles, ...files]);
            // setTimeout(() => {
            setUploadedImages(prevUploadedImages => [...prevUploadedImages, ...newImages]);
            // }, 1000);
        }
    };

    const removeImage = (index) => {
        setUploadedImages(prevUploadedImages => prevUploadedImages.filter((_, i) => i !== index));
        const removedFileName = uploadedImages[index].name;
        setAttachedFiles(prevAttachedFiles => prevAttachedFiles.filter(file => file.name !== removedFileName));
    };

    const renderAttachmentModal = () => {
        return (
            <div className={showProductTrainingModal ? "modal fade show container-fluid" : "modal fade"} id="modalContainer">
                <div className="modal-dialog modal-dialog-centered model-xl" style={{ maxWidth: "80%", borderRadius: 10 }}>
                    <div className="modal-content">
                        <div className="m-0 p-3 pb-0 row justify-content-between align-items-center">
                            <label className="subscriptionHeadertext pl-2">Meeting Photos</label>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginRight: 5, cursor: 'pointer' }} onClick={() => closeAttachmentModal()} color="#000000" size="md" />
                        </div>
                        <div className="modal-body pt-0" style={{ height: '80vh', maxHeight: '90vh' }}>
                            <div className="col-md-12 row activeView justify-content-start align-items-start">
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Add Photos</label>
                                    <div className="customBtn row form-control" onClick={getFile}>
                                        <FontAwesomeIcon icon={['fas', 'upload']} style={{ marginRight: 5, cursor: 'pointer' }} color="#0465AC" size="md" />
                                        <label htmlFor="" className="actionBTN mb-0">Upload Photos</label>
                                    </div>
                                    <input type="file" id="uploadModuleAttachments" multiple onChange={onFileChange} accept=".jpeg,.png,.jpg" hidden />
                                    {
                                        uploadedImages?.length > 0 ? (
                                            <>
                                                {uploadedImages?.map((image, index) => {
                                                    // const extension = name.split('.').pop().toLowerCase();
                                                    const truncatedName = image?.name?.length > 15 ? image?.name?.slice(0, 15) + '...' : image?.name;
                                                    return (
                                                        <div className="row mt-2 justify-content-between align-items-center" key={index}>
                                                            <div className="row align-items-center">
                                                                <div className="extensionDiv p-1">{image.extension}</div>
                                                                <label htmlFor="" className="actionBTN mb-0 ml-2 mr-1" style={{ color: '#000000', textDecoration: 'none' }}>{truncatedName}</label>
                                                            </div>
                                                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginRight: 5, cursor: 'pointer' }} color="#000000" size="md" onClick={() => removeImage(index)} />
                                                        </div>
                                                    )
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <label htmlFor="" className="noteText mt-1 mb-0">Maximum allowed file size - 5 MB </label>
                                                <label htmlFor="" className="noteText mb-0">Allowed file format - .png, .jpg, .jpeg</label>
                                            </>
                                        )
                                    }
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Photo Status <span className="text-danger">*</span></label>
                                    <select className="customDropDown form-control" value={selectedImageStatus} onChange={(e) => setSelectedImageStatus(e.target.value)}>
                                        <option value="">Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">In-Active</option>
                                    </select>
                                    <label htmlFor="" className="noteText text-danger" style={{ textTransform: 'none' }}>{statusError}</label>
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Select Demo <span className="text-danger">*</span></label>
                                    <select disabled={loadingDemoData} className="customDropDown form-control" value={selectedDemoPointId} onChange={(e) => setSelectedDemoPointId(e.target.value)}>
                                        {loadingDemoData ? (
                                            <option value="">Loading ...</option>
                                        ) : (
                                            <>
                                                <option key="" value="">Select Demo</option>
                                                {meetingData?.length > 0 ? (
                                                    meetingData.map(item => (
                                                        <option key={item?.meetingId} value={item?.meetingId}>{item?.meetingName} | {item?.demo_date}</option>
                                                    ))
                                                ) : (
                                                    <option value="">No demo has been scheduled for the selected module.</option>
                                                )}
                                            </>
                                        )}
                                    </select>
                                    <label htmlFor="" className="noteText text-danger" style={{ textTransform: 'none' }}>{demoPointError}</label>
                                </div>
                                <div className="d-flex row pt-3 pb-3 mt-4 pl-4">

                                    <div className="addBtn  mb-3 ml-4" disabled={loadingAddAttachment} onClick={() => apiCallToAddPMAttachments()}>
                                        {
                                            loadingAddAttachment ? <ButtonLoader /> : <label htmlFor="" className="actionBTNAdd mb-0">Add</label>
                                        }
                                    </div>
                                    <div className="addBtn mb-3 ml-1" style={{ backgroundColor: 'transparent' }} onClick={() => closeAttachmentModal()}>
                                        <label htmlFor="" className="actionBTN mb-0">Cancel</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 pl-0 pr-0 justify-content-center">
                                <div className="row justify-content-between align-items-end" style={{ borderBottom: '1px solid #DEE2E7' }}>
                                    <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                        <label htmlFor="" className="actionTitle">Filter by Photo Status </label>
                                        <select className="customDropDown form-control" style={{ height: '5vh' }} value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                                            <option value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">In-Active</option>
                                        </select>
                                    </div>

                                    <label htmlFor="" className="totalRecords">{`Total Records - ${totalAttachments}`}</label>
                                </div>
                                <div className="col-md-12 align-self-center justify-content-center align-items-center mb-4 mt-2 attachmentContainer">
                                    {
                                        selectedAttachments?.length > 0 && (
                                            <div className="inactiveBtn mt-2 mb-2" onClick={() => apiCallToUpdateAttachmentStatus()}>
                                                <label className="inactiveText mb-0">
                                                    {filterStatus === "active" ? "Inactive" : "Active"}
                                                </label>
                                            </div>
                                        )
                                    }
                                    {attachmentsData?.length > 0 ? (
                                        attachmentsData.map(item => (
                                            <div className="attachmentDiv mb-4" key={item.id}>
                                                <div className="position-relative">
                                                    {/* {checkImageWidthAndRenderCheckbox(item.attachmentPath) && ( */}
                                                    <input
                                                        type="checkbox"
                                                        className="position-absolute top-0 start-0 left-4 mt-3 ml-2 ms-2"
                                                        checked={selectedAttachments?.includes(item?.uniqueId)}
                                                        onChange={() => selectAttachment(item?.uniqueId)}
                                                    />
                                                    {/* )} */}
                                                    <img src={item.attachmentPath} className='img-fluid imageResponsive' alt="" />
                                                </div>
                                                <div className="row justify-content-between align-items-center p-2">
                                                    <label className="actionTitle mb-0 pt-4 pl-2" style={{ fontSize: 15 }}>Added By {item?.addedBy}</label>
                                                    <label className="actionTitle mb-0 pt-4 pr-2" style={{ fontSize: 15 }}>{item?.addedOn}</label>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <label className="totalRecords" style={{textTransform:"initial"}}>No meeting photos have been uploaded for selected module. </label>
                                    )}
                                </div>

                            </div>

                            {
                                attachmentsData?.length < totalAttachments && (
                                    <div className="col-md-12 w-100 d-flex justify-content-center align-items-center">
                                        <div className="inactiveBtn mt-2 mb-2" onClick={() => handlePagination()}>
                                            {loadingModuleAttachments ? <ButtonLoader /> : <label htmlFor="" className="inactiveText mb-0">Load More</label>}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div >
            </div >
        )
    }

    const handlePagination = () => {
        setAttachmentPageIndex(prevPageIndex => prevPageIndex + 1);
    };

    const handlePaginationForDocuments = () => {
        setDocumentPageIndex(prevPageIndex => prevPageIndex + 1);
    }

    const returnDocumentModal = () => {
        return (
            <div className={showDocumentModal ? "modal fade show container-fluid" : "modal fade"} id="modalContainer">
                <div className="modal-dialog modal-dialog-centered model-xl" style={{ maxWidth: "80%", borderRadius: 10 }}>
                    <div className="modal-content">
                        <div className="m-0 p-3 pb-0 row justify-content-between align-items-center">
                            <label className="subscriptionHeadertext mb-0 pl-2">Add Product Delivery Document</label>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginRight: 5, cursor: 'pointer' }} onClick={() => closeDocumentModal()} color="#000000" size="md" />
                        </div>
                        <div className="modal-body pt-0" style={{ height: '80vh', maxHeight: '90vh' }}>
                            <div className="col-md-12 align-self-center row activeView justify-content-start align-items-start">
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Module</label>
                                    <input className="customDropDown form-control" value={selectedModuleName} disabled>
                                    </input>
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Sub Module</label>
                                    <select disabled={loadingDemoData} className="customDropDown form-control" value={selectedSubModuleId} onChange={(e) => setSelectedSubModuleId(e.target.value)}>
                                        {loadingSubModules ? (
                                            <option value="">Loading ...</option>
                                        ) : (
                                            <>
                                                {subModuleData?.length > 0 && <option key="" value="">Select Sub Module</option>}
                                                {subModuleData?.length > 0 ? (
                                                    subModuleData.map(item => (
                                                        <option key={item?.uniqueId} value={item?.uniqueId}>{item?.subModuleName}</option>
                                                    ))
                                                ) : (
                                                    <option value="">No sub modules available.</option>
                                                )}
                                            </>
                                        )}
                                    </select>
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Product Training Point <span className="text-danger">*</span></label>
                                    <select disabled={loadingDemoData || selectedSubModuleId == ""} className="customDropDown form-control" value={selectedDemoPointIdForDocument} onChange={(e) => setSelectedDemoPointIdForDocument(e.target.value)}>
                                        {loadingDemoData ? (
                                            <option value="">Loading ...</option>
                                        ) : (
                                            <>
                                                <option key="" value="">Select Demo Point</option>
                                                {demoPointData?.length > 0 ? (
                                                    demoPointData.map(item => (
                                                        <option key={item?.demoId} value={item?.demoId}>{item?.demoPointTitle}</option>
                                                    ))
                                                ) : (
                                                    <option value="">No demo points available.</option>
                                                )}
                                            </>
                                        )}
                                    </select>
                                    <label htmlFor="" className="noteText text-danger" style={{ textTransform: 'none' }}>{demoPointError}</label>
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Add Photos</label>
                                    <div className="customBtn row form-control" onClick={getFile}>
                                        <FontAwesomeIcon icon={['fas', 'upload']} style={{ marginRight: 5, cursor: 'pointer' }} color="#0465AC" size="md" />
                                        <label htmlFor="" className="actionBTN mb-0">Upload Photos</label>
                                    </div>
                                    <input type="file" id="uploadModuleAttachments" multiple onChange={onFileChange} accept=".jpeg,.png,.jpg" hidden />
                                    {
                                        uploadedImages?.length > 0 ? (
                                            <>
                                                {uploadedImages?.map((image, index) => {
                                                    const truncatedName = image?.name?.length > 15 ? image?.name?.slice(0, 15) + '...' : image?.name;
                                                    return (
                                                        <div className="row mt-2 justify-content-between align-items-center" key={index}>
                                                            <div className="row align-items-center">
                                                                <div className="extensionDiv p-1">{image.extension}</div>
                                                                <label htmlFor="" className="actionBTN mb-0 ml-2 mr-1" style={{ color: '#000000', textDecoration: 'none' }}>{truncatedName}</label>
                                                            </div>
                                                            <FontAwesomeIcon icon={['fas', 'times']} style={{ marginRight: 5, cursor: 'pointer' }} color="#000000" size="md" onClick={() => removeImage(index)} />
                                                        </div>
                                                    )
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <label htmlFor="" className="noteText mt-1 mb-0">Maximum allowed file size - 5 MB </label>
                                                <label htmlFor="" className="noteText mb-0">Allowed file format - .png, .jpg, .jpeg</label>
                                                {/* <label htmlFor="" className="noteText mb-0">Allowed Layout - Landscape</label> */}
                                                {/* <label htmlFor="" className="noteText mb-0 text-danger">{landscapeFileError}</label> */}
                                            </>
                                        )
                                    }
                                </div>
                                <div className="d-flex flex-column pt-3 pb-3 pl-4">
                                    <label htmlFor="" className="actionTitle">Photo Status <span className="text-danger">*</span></label>
                                    <select className="customDropDown form-control" value={selectedDocumentStatus} onChange={(e) => setSelectedDocumentStatus(e.target.value)}>
                                        <option value="">Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">In-Active</option>
                                    </select>
                                    <label htmlFor="" className="noteText text-danger" style={{ textTransform: 'none' }}>{statusError}</label>
                                </div>
                                <div className="d-flex row pt-3 pb-3 mt-4 pl-4">

                                    <div className="addBtn mb-3 ml-4" disabled={loadingAddAttachment} onClick={() => apiCallToAddPMDocuments()}>
                                        {
                                            loadingAddAttachment ? <ButtonLoader /> : <label htmlFor="" className="actionBTNAdd mb-0">Add</label>
                                        }
                                    </div>
                                    <div className="addBtn mb-3 ml-1" style={{ backgroundColor: 'transparent' }} onClick={() => closeDocumentModal()}>
                                        <label htmlFor="" className="actionBTN mb-0">Cancel</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 align-self-center mt-3 mb-3 infoView d-flex flex-column justify-content-center align-items-center ">
                                <label className="instituteName mb-0">{`${config?.institute_name} | ${config?.instructorInfo?.AcaYear}`}</label>
                                <label className="instituteName mb-0">Product Delivery Confirmation Report</label>
                                <label className="instituteName mb-0 font-weight-bold">{`Product Delivery Documents | ${selectedModuleName}`}</label>
                            </div>

                            <div className="col-md-12 pl-0 pr-0 align-self-center justify-content-center align-items-center mb-4 mt-2 attachmentContainer">
                                {documentsData?.length > 0 ? (
                                    documentsData.map(item => (
                                        <div className="attachmentDiv mb-4" key={item.id}>
                                            <div className="position-relative">
                                                <img src={item.attachmentPath} className='img-fluid imageResponsive' alt="" />
                                            </div>
                                            <div className="row justify-content-between align-items-center p-2">
                                                <label className="actionTitle mb-0 pt-4 pl-2" style={{ fontSize: 15 }}>Added By {item?.addedBy}</label>
                                                <label className="actionTitle mb-0 pt-4 pr-2" style={{ fontSize: 15 }}>{item?.addedOn}</label>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <label className="totalRecords" style={{textTransform:"initial"}}>Attachments are not available for the selected module.</label>
                                )}
                            </div>

                            {
                                documentsData?.length < totalDocuments && (
                                    <div className="col-md-12 w-100 d-flex justify-content-center align-items-center">
                                        <div className="inactiveBtn mt-2 mb-2" onClick={() => handlePaginationForDocuments()}>
                                            {loadingModuleDocuments ? <ButtonLoader /> : <label htmlFor="" className="inactiveText mb-0">Load More</label>}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const openAttachmentModal = async (moduleId) => {
        setSelectedModuleId(moduleId);
        setShowProductTrainingModal(true);
        setAttachmentsData([]);
        await apiCallToGetModuleAttachments(moduleId);
        await apiCallToGetDemoMeetingList(moduleId);
    }

    const openDocumentModal = async (moduleId, moduleName) => {
        const type = "product-delivery-confirmation";
        setSelectedModuleId(moduleId);
        setSelectedModuleName(moduleName);
        setShowDocumentModal(true);
        await apiCallToGetModuleDocuments(moduleId);
        // await apiCallToGetDemoPointList(moduleId, type);
        await apiCallToGetSubModuleList(moduleId);
    }

    const closeDocumentModal = () => {
        setAttachedFiles([]);
        setUploadedImages([]);
        setDocumentsData([]);

        setSelectedModuleId('');
        setSelectedSubModuleId('');
        setSelectedDocumentStatus('active');
        setSelectedDemoPointIdForDocument('');

        setShowDocumentModal(false);
    }

    const closeAttachmentModal = () => {
        setSelectedModuleId('');
        setFilterStatus('active');
        setSelectedImageStatus('active');
        setSelectedDemoPointId('');

        setAttachedFiles([]);
        setUploadedImages([]);

        setShowProductTrainingModal(false);
    }

    //FUNCTION FOR GET  ADD FILE
    const getFile = () => {
        document.getElementById("uploadModuleAttachments").click();
    }

    return (
        <div className="productTrainingContainer mr-4">
            <div className="col-md-12 pt-3 row justify-content-between align-items-center">
                <label htmlFor="" className="linkText" style={{ textDecoration: 'underline' }} onClick={() => setShowSubscriptionModal(true)}>View My Subscription Package</label>
                {/* <div className="printBtn row justify-content-center align-items-center p-2 pl-3 pr-3" onClick={() => handlePrintReport()}>
                    <FontAwesomeIcon icon={['fas', 'print']} style={{ cursor: 'pointer' }} color='#0465AC' size="md" />
                    <label htmlFor="" className="linkText mb-0 pl-2">Print Report</label>
                </div> */}
            </div>
            <div className="table-container mt-3 p-0" style={{ border: '1px solid #8282824D' }}>
                <div className="table-responsive table-container m-0 p-0" style={{ maxHeight: 520 }}>
                    <table className="table m-0 table-container_sticky" >
                        <thead className='table-container_sticky table-header-onboarding m-0'>
                            <tr>
                                <th className='table-container_sticky' scope="col" style={{ paddingLeft: 10 }}>Phases</th>
                                <th className='table-container_sticky' scope="col">Product Training</th>
                                <th className='table-container_sticky' scope="col">Meeting Photos</th>
                                <th className='table-container_sticky' scope="col">Product Delivery</th>
                                <th className='table-container_sticky' scope="col">Training Status</th>
                            </tr>
                        </thead>
                        {
                            loadingProductTrainingData ? (
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style={{ display: "flex", justifyContent: "center" }}> <ButtonLoader /></td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            ) : Object.keys(productTrainingData).length > 0 ? (
                                sortedPhases.map(phase => {
                                    const productTrainingObject = productTrainingData[phase];
                                    if (productTrainingObject) {
                                        return Object.values(productTrainingObject).length > 0 ? (
                                            <>
                                                <tbody key={`${phase}-tbody`}>
                                                    <tr key={phase}>
                                                        <th style={{ padding: 5, paddingLeft: 10, backgroundColor: '#F4F6FA' }} colSpan={5}>
                                                            {phase === "phase5" ? "Phase 5" :
                                                                phase === "phase4" ? "Phase 4" :
                                                                    phase === "phase3" ? "Phase 3" :
                                                                        phase === "phase2" ? "Phase 2" :
                                                                            "Phase 1"}
                                                        </th>
                                                    </tr>
                                                    {Object.values(productTrainingObject).map((item, index) => {

                                                        const totalDeliveryCount = item.totalDeliveryCount;
                                                        const completedDeliveryCount = item.completedDeliverCount;
                                                        const pendingDeliveryCount = totalDeliveryCount - completedDeliveryCount;
                                                        const status = totalDeliveryCount === completedDeliveryCount && completedDeliveryCount > 0 ? "completed" : completedDeliveryCount === 0 ? "notYetStarted" : "pending";
                                                        const attachmentColor = item?.totalAttachments === 0 ? '#959595' : '#1781FF';
                                                        const deliveryColor = status !== "completed" ?( completedDeliveryCount  > 0? '#1781FF' :  '#959595') : '#319800';
                                                        const completedTrainingCount = item?.completedProductTrainingCount;
                                                        const pendingTrainingCount = item?.pendingProductTrainingCount;
                                                        const totalProductTrainingCount = completedTrainingCount + pendingTrainingCount;

                                                        return (
                                                            <tr key={`${phase}-${index}`}>
                                                                <td style={{ padding: 5, paddingLeft: 10, }} scope="row">{item?.moduleName}</td>
                                                                <td scope="row" style={{ padding: 5, paddingLeft: 10, color: completedTrainingCount === 0 ? "#F44848" : totalProductTrainingCount === completedTrainingCount ? "#319800" : "#FFA14B" }}>
                                                                    {`${completedTrainingCount}/${totalProductTrainingCount}`}
                                                                </td>
                                                                <td style={{ padding: 5, paddingLeft: 10, }} scope="row">
                                                                    <div className="p-0 row align-items-center" style={{ cursor: 'pointer' }} onClick={() => openAttachmentModal(item?.moduleId)}>
                                                                        <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 5 }} color={attachmentColor} size="md" />
                                                                        <p style={{ color: attachmentColor }}>{item?.totalAttachments}</p>
                                                                    </div>
                                                                </td>
                                                                <td style={{ padding: 5, paddingLeft: 10, }} scope="row">
                                                                    <div className="p-0 row align-items-center" style={{ cursor: 'pointer' }} onClick={() => openDocumentModal(item?.moduleId, item?.moduleName)}>
                                                                        <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 5 }} color={deliveryColor} size="md" />
                                                                        <p style={{ color: deliveryColor, cursor: 'pointer' }}>{`${completedDeliveryCount}/${totalDeliveryCount}`}</p>
                                                                    </div>
                                                                </td>
                                                                <td style={{ padding: 5, paddingLeft: 10, }} scope="row">
                                                                    <div className={status === "notYetStarted" ? "notYetStartedDiv" : status === "completed" ? "completedDiv" : "pendingDiv"}>
                                                                        <p className={status === "notYetStarted" ? "notYetStartedText" : status === "completed" ? "completedText" : "pendingText"}>
                                                                            {status === "notYetStarted" ? "Not Yet Started" : status === "completed" ? "Completed" : "In-progress"}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </>
                                        ) : (
                                            <tr key={`${phase}-no-data`}>
                                                <th style={{ backgroundColor: '#F4F6FA' }} colSpan={5}>No Data Available</th>
                                            </tr>
                                        );
                                    } else {
                                        return <></>
                                    }
                                })
                            ) : (
                                <tr>
                                    <th style={{ backgroundColor: '#F4F6FA' }} colSpan={5}>No modules have been added yet.</th>
                                </tr>
                            )
                        }
                    </table>
                </div>

            </div>
            <div className="mb-5" />
            {renderSubscriptionModal()}
            {renderAttachmentModal()}
            {returnDocumentModal()}
            {
                successModal &&
                <SuccessModal
                    successModal={successModal}
                    successModalType={successType}
                    successMessage={successMessage}
                    closeSuccessModal={closeSuccessModal}
                />
            }
        </div>
    )
}

const OnboardingTab = () => {
    return (
        <div className="">Onboarding Tab</div>
    )
}